import type { ResetPasswordFormData } from '@/widgets/auth/ResetPassword/models';

import { baseClient } from '@/shared/api/baseClient';

export const resetPasswordAsync = async (data: ResetPasswordFormData) => {
  const response = await baseClient.post<void>('/auth/reset-password', data);
  return response.data;
};
